import Link, { LinkProps } from "next/link";
import React, { forwardRef, memo } from "react";

const AppLink = forwardRef<HTMLAnchorElement, AppLinkProps>((props, ref) => {
  const { href, as, download, children, target, ...otherProps } = props;

  return (
    <Link
      href={href || "#"}
      as={as}
      ref={ref}
      download={download}
      {...otherProps}
      target={target}
    >
      {children}
    </Link>
  );
});

AppLink.displayName = "AppLink";

export type AppLinkProps = LinkProps & {
  children: React.ReactElement;
  download: boolean;
  target: React.HTMLAttributeAnchorTarget | undefined;
};

export default memo(AppLink);
